const LandingSet = {
    title1: {
        English: "Financial Analytics",
        German: 'Selbstbewertungstool',
        French: 'Outil d’auto-évaluation',
        Russian: 'Инструмент для самостоятельной',
        Turkish: 'Finansal',
        Italian: 'Strumento di autovalutazione',
        Spanish: 'Herramienta de autoevaluación',
        PortugueseBR: 'Ferramenta de autoavaliação',
        SpanishLAD: 'Herramienta de autoevaluación',
    },
    title2: {
        English: "Self-Assessment",
        German: 'für das Finanzwesen',
        French: "financière",
        Russian: "оценки финансовых процессов",
        Turkish: "öz değerlendirme aracı",
        Italian: "del Finance",
        Spanish: "de los procesos financieros",
        PortugueseBR: "financeira",
        SpanishLAD: "financiera",
    },
    landingCopy: {
        English: "Find out how your financial analytics processes stack up against best-in-class organizations.",
        German: "Erfahren Sie, wie Ihre Finanzprozesse im Vergleich zu denen erstklassiger Unternehmen dastehen.",
        French: "Comparez vos processus financiers à ceux des entreprises leader de leur secteur.",
        Russian: "Узнайте, насколько эффективно построены ваши финансовые процессы по сравнению с лучшими в своем классе организациями.",
        Turkish:"Finans süreçlerinizin sınıfının en iyisi kuruluşlara kıyasla ne durumda olduğunu öğrenin",
        Italian: "Metti i tuoi processi amministrativi, finanziari e di controllo (AFC) a confronto con quelli delle società di maggiore successo.",
        Spanish: "Averigüe cómo son sus procesos financieros en comparación con los de las mejores organizaciones.",
        PortugueseBR: "Descubra como seus processos financeiros se comparam aos das melhores organizações.",
        SpanishLAD: "Descubre cómo se comparan tus procesos financieros con las mejores organizaciones de su clase.",
    },
    getStarted: {
        English: "Get Started",
        German: 'Loslegen',
        French: "Commencer",
        Russian: "Начать",
        Turkish: "Başla",
        Italian: "Inizia",
        Spanish: "Comenzar",
        PortugueseBR: "Comece já",
        SpanishLAD: "Introducción",
    },
    restartBtn: {
        English: "Restart",
        German: 'Neustarten',
        French: "Recommencer",
        Russian: "Начать сначала",
        Turkish: "Tekrar Başlat",
        Italian: "Ricomincia",
        Spanish: "Reiniciar",
        PortugueseBR: "Reiniciar",
        SpanishLAD: "Reiniciar",
    },
    nextBtn: {
        English: "Next",
        German: 'Weiter',
        French: "Suivant",
        Russian: "Далее",
        Turkish: "Sonraki",
        Italian: "Avanti",
        Spanish: "Siguiente",
        PortugueseBR: "Avançar",
        SpanishLAD: "Siguiente",

    },
    finishBtn: {
        English: "Finish",
        German: 'Beenden',
        French: "Terminer",
        Russian: "Завершить",
        Turkish: "Bitir",
        Italian: "Termina",
        Spanish: "Finalizar",
        PortugueseBR: "Concluir",
        SpanishLAD: "Finalizar",
    }
};

export default LandingSet;
